module.exports = __webpack_public_path__ + "static/media/ic_iids-logo.b1dcaf15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_iids-logo.svg
// module id = 554
// module chunks = 12